import React from "react";

export const useInputChange = (update: (value: string) => void) =>
  React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      update(event.currentTarget.value);
    },
    [update],
  );
